import { MapTo } from '@adobe/cq-react-editable-components';
import Loadable from '../../../../utils/loadable';

const saveCart = Loadable(() => import('../../containers/web/saveCart'));
export default MapTo('vcg/components/soe-home/react/saveCart')(saveCart);
